<template>
    <form-wizard
        @on-change="handleOnChange"
        class="form-wizard"
        ref="FormWizard"
        v-bind="$props"
    >
        <slot />

        <template
            slot-scope="props"
            slot="footer"
        >
            <div class="wizard-footer-left">
                <rkm-button
                    v-if="props.activeTabIndex"
                    :disabled="disabledPrevButton"
                    @click.stop="props.prevTab()"
                    color="primary"
                >
                    Voltar
                </rkm-button>
            </div>

            <div class="wizard-footer-right">
                <rkm-button
                    v-if="!props.isLastStep"
                    :disabled="disabledNextButton"
                    @click.stop="props.nextTab()"
                    color="primary"
                >
                    Próximo
                </rkm-button>

                <rkm-button
                    v-else
                    :disabled="disabledFinishButton"
                    @click.stop="$emit('finish')"
                    color="primary"
                >
                    Concluir
                </rkm-button>
            </div>
        </template>
    </form-wizard>
</template>

<script>
// Components.
import { FormWizard } from 'vue-form-wizard'
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch()

export default {
    components: { FormWizard },
    methods: {
        reset() {
            this.$refs.FormWizard.reset()
        },
        activateAll() {
            this.$refs.FormWizard.activateAll()
        },
        nextTab() {
            this.$refs.FormWizard.nextTab()
        },
        prevTab() {
            this.$refs.FormWizard.prevTab()
        },
        changeTab(oldIndex, newIndex) {
            this.$refs.FormWizard.changeTab(oldIndex, newIndex)
        },
        handleOnChange(prevIndex, nextIndex) {
            if (this.scrollToTopOnChange) {
                scrollTo(0, 0);
            }

            this.$emit('change', prevIndex, nextIndex)
        },
    },
    props: {
        color: { type: String, default: 'var(--primary)' },
        disabledFinishButton: { type: Boolean, default: false },
        disabledNextButton: { type: Boolean, default: false },
        disabledPrevButton: { type: Boolean, default: false },
        scrollToTopOnChange: { type: Boolean, default: true },
        shape: { type: String, default: 'circle' },
        subtitle: { type: String, default: '' },
        title: { type: String, default: '' },
    },
}
</script>

<style scoped>
.form-wizard >>> [role="tablist"] {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: -0.75rem 0 0.75rem 0;
    padding: 0;
}
.form-wizard >>> [role="tablist"] li {
    flex: 1;
    list-style: none;
}
.form-wizard >>> [role="tablist"] li a {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    padding: 0 1rem;
    position: relative;
    text-decoration: none;
}
.form-wizard >>> a.disabled {
    color: var(--gray);
    cursor: not-allowed;
    opacity: 0.6;
}
.form-wizard >>> .wizard-icon-circle {
    align-items: center;
    border-radius: 100%;
    border: 1px solid currentColor !important;
    color: #FFF;
    color: currentColor;
    display: flex;
    height: 50px;
    justify-content: center;
    line-height: 1;
    width: 50px;
}
.form-wizard >>> .active .wizard-icon-circle {
    background: var(--primary);
    color: #FFF;
}
.form-wizard >>> .wizard-icon {
    font-size: 18px;
    font-style: normal;
    font-weight: 200;
}
.wizard-icon-container {
    background: none !important;
}
.wizard-icon {
    font-style: normal;
}
.form-wizard >>> [role="tablist"] li + li a:before {
    background: currentColor;
    content: '';
    display: block;
    height: 2px;
    left: -20%;
    position: absolute;
    top: 24px;
    width: 40%;
}
.form-wizard >>> .wizard-card-footer {
    border-top: 1px solid #dee2e6;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 1rem -0.75rem 0;
    padding: 0.75rem 0.75rem 0 0.75rem;
}
.form-wizard >>> .wizard-footer-left, .form-wizard >>> .wizard-footer-right {
    flex-shrink: 1;
}
.form-wizard >>> .wizard-card-footer:after {
    display: none !important;
}
</style>